export const PROMQL_THINKING_MESSAGES: string[] = [
  'Searching metrics...',
  'Analyzing labels...',
  'Generating PromQL...',
];
